<template>
  <div class="be-skeleton-loader">
    <v-skeleton-loader
      v-for="idx in rows"
      :key="idx"
      transition="slide-x-transition"
      :class="`mx-auto ${mt}`"
      :type="type"
      :dark="isHighContrast"
    ></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  name: "be-skeleton-loader",
  props: {
    type: {
      required: false,
      type: String,
      default: "article",
    },
    rows: {
      required: false,
      type: Number,
      default: 1,
    },
    mt: {
      required: false,
      type: String,
      default: "mt-3",
    },
  },
  computed: {
    isHighContrast() {
      return !!(this?.$store?.state?.contrast === 'high');
    },
  }
};
</script>

<style lang="scss" scoped>
.be-skeleton-loader ::v-deep .v-skeleton-loader__article {
  background-color: #ffffffcf;
}
</style>
